// Detects any version of  IE/EDGE
export const detectIE = () => {
  const ua = window.navigator.userAgent

  const msie = ua.indexOf('MSIE ')
  const trident = ua.indexOf('Trident/')
  const edge = ua.indexOf('Edge/')

  return msie > 0 || trident > 0 || edge > 0
}

export const formatDate = (stringDate, format) => {
  const days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ]
  const shortMonths = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sept',
    'oct',
    'nov',
    'dec'
  ]

  switch (format) {
    case 'short':
      const parseDate = (stringDate.indexOf('T') > -1) ?
        stringDate.split('T')[0].replace(/-/g, '/') :
        stringDate

      const date = new Date(parseDate)

      return `${days[date.getDay()]}, ${shortMonths[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`

    case 'dateOfBirth':
      const dob = stringDate.split('-')

      return `${dob[1]}/${dob[2]}/${dob[0]}`

    default:
      return date
  }
}

export default detectIE



// WEBPACK FOOTER //
// ./src/utils/systemUtils.js